import React from 'react';
import { HelpCircle } from 'lucide-react';

/**
 * Opens the HP service reference beside a service picker.
 *
 * The words "What do these mean?" sat next to every picker and crowded the
 * field label, so they moved into a tooltip and only the icon is left standing.
 * It sits inside a <label>, so it must be a type="button" or clicking it
 * submits the surrounding form.
 *
 * The bubble is the visual copy only: the same words are the button's
 * accessible name, so it is hidden from assistive tech rather than announced
 * twice. `:focus-within` on the wrapper shows it for keyboard users too.
 */
export default function ServiceGuideButton({ onClick, label = 'What do these mean?' }) {
  return (
    <span className="help-tip">
      <button type="button" className="help-tip-button" onClick={onClick} aria-label={label}>
        <HelpCircle size={14} aria-hidden="true" />
      </button>
      <span className="help-tip-bubble" aria-hidden="true">
        {label}
      </span>
    </span>
  );
}
